<template>
  <div class="about">
    <div
      class="flex flex-col items-center justify-center mx-6 mt-8 md:mt-16 mb-10 secondary text-gray-900"
    >
      <h1 class="text-xl md:text-xl mb-12 leading-loose tracking-wide">
        Get your NFT art to the top of the gallery
      </h1>

      <div class="text-lg md:text-xl leading-loose tracking-wide">
        <p class="mb-4">
          With VeryNifty you can wrap your NFTS and turn them into vNFTs
        </p>

        <p class="mb-4">
          Your vNFTs earn you MUSE (erc20) once a day by clicking on claim
          rewards.
        </p>
        <p class="mb-4">
          Use MUSE to buy different gems and raise in the leaderboard, the
          higher you are in the leaderboard the more MUSE you'll mine daily.
        </p>
        <p class="mb-4">
          Careful though, if you don't buy gems for several days your vNFT will
          die and get burned and won't be able to mine any more MUSE.
        </p>
        <p class="mb-4">
          You can look out for dead vNFTs on the leaderboard, if they are dead
          you can burn them and claim 60% of their points by clicking on the
          skull.
        </p>
      </div>
      <div class="mt-10 flex -mx-4">
        <div class="px-4">
          <button class="btn">
            <router-link to="/wrap">Wrap Your NFT</router-link>
          </button>
        </div>
        <div class="px-4">
          <button class="btn flex items-center justify-center -mx-2 w-64">
            <img
              :src="require('../assets/img/vnftLogo.svg')"
              class="h-8 px-2"
            />
            <router-link class="px-2 inline-block" to="/play"
              >Check My vNFTs</router-link
            >
          </button>
        </div>
      </div>
    </div>
    <Modal
      v-if="showModal"
      @close="showModal = false"
      :text="`The VeryNifty Gallery game has ended! thi site is for historic purposes only and the surviving NFTs are collectibles that can be seen on nft20.io/nfts.  The game ran for 3 months and was a war for survival of the fittest and to get part of the MUSE supply, only 500 pets survived.`"
      :title="`vNFT is not an investment vehicle.`"
      :button="`I understand & agree.`"
    />
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Modal,
  },
  data: function () {
    return {
      showModal: true,
    };
  },
  mounted: function () {},
};
</script>
